const JOB_STATUSES = [
    { code: -1, label: 'En cours', icon: 'sync', color: 'blue' },
    { code: 0, label: 'Erreur', icon: 'error', color: 'red' },
    { code: 1, label: 'Succès', icon: 'done', color: 'green' },
    { code: 2, label: 'Succès (avec warnings)', icon: 'done', color: 'green' },
    { code: 3, label: 'Interrompu manuellement', icon: 'pan_tool', color: 'orange' },
    { code: 4, label: 'Aucune donnée à traiter', icon: 'local_cafe', color: 'grey' },
    { code: 5, label: 'Aucune information / pas de réponse', icon: 'live_help', color: 'orange' },
    { code: 6, label: 'Résultat inconnu (aucun log de succès ou d\'erreur)', icon: 'more_horiz', color: 'blue' },
    { code: 7, label: 'Interrompu pour\nmaintenance de l\'application', icon: 'pan_tool', color: 'blue' },
    { code: 8, label: 'Traitement non exécuté', icon: 'hourglass_full', color: 'orange' },
    { code: 9, label: 'Non lancé car la précédente exécution est toujours en cours', icon: 'sync_problem', color: 'orange' },
]

const getStatusJob = status => JOB_STATUSES.find(s => s.code === status) ?? { code: status, label: String(status) }

export { JOB_STATUSES, getStatusJob }
